/**
 * Created by alexey on 28.09.2025
 */

const WoodenUILandmarkSelectItem = cc.Node.extend({
    ctor: function (landmark) {
        this._super();
        this.landmark = landmark;
        this.selected = false;
        const styles = cleverapps.styles.WoodenUILandmarkSelectItem;

        this.setContentSize2(styles.unit_background);

        const unitView = this.unitView = UnitView.getUnitImage(landmark, { preferStatic: true, useLibraryAnchors: true });
        cleverapps.UI.fitToBox(this.unitView, styles.unit);
        unitView.setAlignment(styles.unit);
        this.unitView.setCascadeOpacityEnabledRecursively(true);
        this.unitView.setCascadeColorEnabled(true);
        this.addChild(unitView);
        unitView.setOpacity(150);

        this.setTitle();
    },

    setTitle: function () {
        const styles = cleverapps.styles.WoodenUILandmarkSelectItem;
        const titleNode = cleverapps.UI.createScale9Sprite(bundles.landmarkselectwindow.frames.name_bg);
        const text = cleverapps.unitsLibrary.getUnitName(this.landmark);
        const title = this.title = cleverapps.UI.generateOnlyText(text, cleverapps.styles.FONTS.ACHIEVEMENT_ITEM_TEXT);
        titleNode.addChild(title);
        titleNode.setContentSize2(styles.title);
        this.addChild(titleNode);
        title.setAlignment(titleNode.width / 2, titleNode.height / 2);
        title.fitTo(titleNode.width * 0.8, titleNode.height * 0.9);
        titleNode.setAlignment(styles.title);
    },

    createShadow: function () {
        this.removeShadow();

        const currentColor = this.unitView.getColor();
        const shadow = this.shadow = 0.4;

        const newR = Math.floor(currentColor.r * shadow);
        const newG = Math.floor(currentColor.g * shadow);
        const newB = Math.floor(currentColor.b * shadow);

        this.unitView.setColor(new cc.Color(newR, newG, newB, currentColor.a));
    },

    addButton: function () {
        const styles = cleverapps.styles.WoodenUILandmarkSelectItem;

        this.removeButton();
        const content = new cc.Node();
        const icon = new cc.Sprite(bundles.landmarkselectwindow.frames.magnifier_icon);
        content.addChild(icon);

        const button = this.button = new cleverapps.UI.Button({
            type: cleverapps.styles.UI.Button.Images.small_button_blue,
            onClicked: this.findButtonClick.bind(this),
            content,
            width: styles.button.width,
            height: styles.button.height
        });
        this.addChild(button);
        button.setAlignment(styles.button);
        this.button.background.setOpacity(0);
    },

    removeButton: function () {
        if (this.button) {
            this.button.removeFromParent();
            this.button = undefined;
        }
    },

    removeShadow: function () {
        if (this.shadow) {
            const currentColor = this.unitView.getColor();

            const newR = Math.floor(currentColor.r / this.shadow);
            const newG = Math.floor(currentColor.g / this.shadow);
            const newB = Math.floor(currentColor.b / this.shadow);

            this.unitView.setColor(new cc.Color(newR, newG, newB, currentColor.a));
            this.shadow = undefined;
        }
    },

    findButtonClick: function () {
        if (typeof StickersBook2 !== "undefined" && StickersBook2.isMainPrizeLandmark(this.landmark)) {
            StickersBook2.openBookWindow();
            return;
        }

        if (Map2dLocation.currentLocation.landmarks.isOnMap(this.landmark)) {
            cleverapps.focusManager.currentWindow().close();
            Map2dScroller.currentScroller.cancelZoomOut();
            UnitLocator.find(Map2d.OPEN_UNIT, this.landmark, { allowScrollWithFocus: true });
            return;
        }

        cleverapps.focusManager.display({
            focus: "AchievementExplanationWindow",
            stack: true,
            action: (f) => {
                new AchievementExplanationWindow(this.landmark);
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
    },

    setCheckmark: function () {
        if (this.selected && !this.checkmark) {
            this.checkmark = new cc.Sprite(bundles.landmarkselectwindow.frames.checkmark);
            this.checkmark.setAlignment(cleverapps.styles.WoodenUILandmarkSelectItem.checkmark);
            this.addChild(this.checkmark);
        } else if (!this.selected && this.checkmark) {
            this.checkmark.removeFromParent();
            delete this.checkmark;
        }
    },

    canDeploy: function () {
        return Map2dLocation.currentLocation.landmarks.canDeploy(this.landmark);
    },

    canHint: function () {
        return !this.canDeploy() && !this.selected;
    },

    updateState: function () {
        if (this.getDeployed()) {
            this.setOpened(true);
            this.setSelected(true);
        } else {
            this.setOpened(Map2dLocation.currentLocation.landmarks.canDeploy(this.landmark));
            this.setSelected(false);
        }

        if (this.canHint()) {
            this.createShadow();
            this.addButton();
        } else {
            this.removeShadow();
            this.removeButton();
        }
    },

    getDeployed: function () {
        return Map2dLocation.currentLocation.landmarks.listDeployed().find(function (unit) {
            return Unit.IsApplicable(this.landmark, unit);
        }, this);
    },

    setOpened: function (opened) {
        this.unitView.setOpacity(opened ? 255 : 150);
    },

    setSelected: function (state) {
        if (state === this.selected) {
            return;
        }

        this.selected = state;
        this.setCheckmark();
        this.setScale(state ? 1.1 : 1.0);
        this.baseScale = state ? 1.1 : 1.0;
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    ACHIEVEMENT_ITEM_TEXT: {
        size: 25,
        color: new cc.Color(192, 110, 26)
    }
});

cleverapps.styles.WoodenUILandmarkSelectItem = {
    title: {
        x: { align: "center", dx: 0 },
        y: { align: "bottom", dy: -90 },

        width: 200,
        height: 50
    },

    unit: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: -5 },

        width: 200,
        height: 200
    },

    unit_background: {
        width: 200,
        height: 100
    },

    button: {
        x: { align: "right", dx: -7 },
        y: { align: "top", dy: 20 },
        width: 70,
        height: 70,
        content: {
            width: 50,
            height: 70
        }
    },

    minimal_dialogue: {
        scale: 0.7
    },

    checkmark: {
        x: { align: "right", dx: 0 },
        y: { align: "top", dy: 20 },
        width: 70,
        height: 70
    }
};